import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { setAnonId } from 'Redux/ducks/anonymous';

// The id generated on this page load, if any. Lets initial load skip fetching a basket that can't exist yet.
let generatedAnonId = null;

export const getGeneratedAnonId = () => generatedAnonId;

function AnonymousId({ id, set }) {
  useEffect(() => {
    if (!id) {
      generatedAnonId = crypto.randomUUID();
      set(generatedAnonId);
    }
  }, [id, set]);

  return false;
}

AnonymousId.propTypes = {
  id: PropTypes.string,
  set: PropTypes.func.isRequired,
};

AnonymousId.defaultProps = {
  id: null,
};

export default connect(({ anonymous: { id } }) => ({ id }), { set: setAnonId })(AnonymousId);
